import { useState } from "react";

import { SelectorContainer, MonthSelectorModalContainer } from "./styled";
import { Modal } from "../../components";
import { useMonthSelector, useOutsideAlerter } from "../../hooks";

export const MonthSelector = ({
  value,
  onChange,
  placeholder,
  selectedStartMonth,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const {
    orderedMonthes,
    isDisabled,
    getYear,
    selected,
    selectedIndex,
  } = useMonthSelector({
    value,
    onChange,
    selectedStartMonth,
  });

  return (
    <>
      <SelectorContainer
        onClick={() => {
          setIsOpen(true);
        }}
      >
        <h4>{placeholder}</h4>
        <p>
          {value ? `${selected.label}  سال ${getYear(selectedIndex)}` : null}
        </p>
      </SelectorContainer>
      {isOpen && (
        <MonthSelectorModal
          closeModal={() => {
            setIsOpen(false);
          }}
          orderedMonthes={orderedMonthes}
          isDisabled={isDisabled}
          getYear={getYear}
          value={value}
          onChange={onChange}
        />
      )}
    </>
  );
};

const MonthSelectorModal = ({
  orderedMonthes,
  isDisabled,
  getYear,
  value,
  onChange,
  closeModal,
}) => {
  const [ref] = useOutsideAlerter(closeModal, true);

  return (
    <Modal isSelector>
      <MonthSelectorModalContainer ref={ref}>
        {orderedMonthes.map((item, index) => (
          <div
            key={item.value}
            onClick={() => {
              if (!isDisabled(index)) {
                onChange(item.value);
                closeModal();
              }
            }}
            className={`item ${item.value === value ? "selected" : ""} ${
              isDisabled(index) ? "disabled" : ""
            }`}
          >
            <label>{item.label}</label>
            <span>سال {getYear(index)}</span>
          </div>
        ))}
      </MonthSelectorModalContainer>
    </Modal>
  );
};
